import Response from '../base/Response';

export default class TimeoutResponse extends Response {

}
